import { render, staticRenderFns } from "./CustomImageDetail.vue?vue&type=template&id=1f4444aa"
import script from "./CustomImageDetail.vue?vue&type=script&lang=js"
export * from "./CustomImageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports